import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import { unloadProject, viewProject } from '../../modules/projectModule/project';
import { unloadOrder, viewOrder } from '../../modules/projectModule/order';
import OrderBookApprovalContainer from '../projectmng/obtainorder/OrderBookApprovalContainer';
import OrderBookInfoContainer from '../projectmng/obtainorder/OrderBookInfoContainer';
import OrderProductListContainer from '../projectmng/obtainorder/OrderProductListContainer';
import ApprovalFormContainer from './ApprovalFormContainer';
import SalesProfitInfoContainer from '../projectmng/obtainorder/SalesProfitInfoContainer';
import ApprovalSummary from '../../components/approval/ApprovalSummary';

const ApprovalOrderViewContainer = ({ id }) => {
  const dispatch = useDispatch();
  const { project, user, receiveOrderInf, approval, approvalList, loading } =
    useSelector(({ auth, projectModule, userModule, loading }) => ({
      user: auth.user,
      approval: userModule.approval.approval,
      project: projectModule.project.project,
      receiveOrderInf: projectModule.order.receiveOrderInf,
      approvalList: projectModule.order.approvalList,
      loading: loading['project/VIEW_ORDER'],
    }));

  const mergedApproval = approval ? {
    ...approval,
    expDay: receiveOrderInf?.expDay || '',
    salesNm: receiveOrderInf?.salesNm || ''
  } : null;

  useEffect(() => {
    if (id) dispatch(viewOrder(id));
    return () => unloadOrder();
  }, [dispatch, id]);

  useEffect(() => {
    if (receiveOrderInf) dispatch(viewProject(receiveOrderInf.prjUuid));
    return () => unloadProject();
  }, [dispatch, receiveOrderInf]);

  if (loading || !receiveOrderInf || !project) return null;

  return (
    <>
      <DetailTemplate title="결재 정보">
        <ApprovalSummary info={mergedApproval} />
        
        {receiveOrderInf?.ordYn === 'S' && (
          <Box
            sx={{
              position: 'sticky',
              top: 80,           
              zIndex: 1200,      
              bgcolor: '#fff',   
              my: 1,             
              borderColor: 'divider',
              boxShadow: '0 4px 2px -2px rgba(0,0,0,0.05)', 
            }}
          >
            <ApprovalFormContainer
              docuCd={receiveOrderInf?.roUuid}
              user={user}
              type="order"
            />
          </Box>
        )}

        {/* 결재 내역 */}
        <Box sx={{ width: '100%', mt: 0.5 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            bgcolor: '#fff',
            border: '1px solid #ddd', 
            borderRadius: '4px',
            overflow: 'hidden',
            minHeight: '32px'
          }}>
            <Box sx={{ pl: 1.5, pr: 1, display: 'flex', alignItems: 'center', minWidth: '90px' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1 }}>
                결재 내역
              </Typography>
            </Box>
            <Box sx={{ flex: 1, overflowX: 'auto', py: 0.2 }}>
              <OrderBookApprovalContainer approvalList={approvalList} />
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1 }}>
            <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
              <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
                <Typography 
                  variant="subtitle1" 
                  sx={{ fontWeight: 'bold', lineHeight: 1.2, backgroundColor: 'transparent' }}
                >
                  상세 내역
                </Typography>
              </Box>
            </Box>
            <OrderBookInfoContainer orderInfo={receiveOrderInf} project={project} isLink />
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1 }}>
            <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
              <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                  최종 매출 이익 (내부거래 포함)
                </Typography>
              </Box>
            </Box>
            <SalesProfitInfoContainer orderInfo={receiveOrderInf} project={project} />
          </Box>
        </Box>
        <Box sx={{ mt: 1, mb: 3 }}>
          <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 1, overflow: 'hidden' }}>
            <Box sx={{ px: 0.5, pt: 1.2, bgcolor: 'rgba(25, 118, 210, 0.15)' }}>
              <Box sx={{ pb: 0.8, mx: 1, backgroundColor: 'transparent' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                  원가 산출 내역
                </Typography>
              </Box>
            </Box>
            <Box sx={{ py: 1.5, px: 2 }}>
              <OrderProductListContainer />
            </Box>
          </Box>
        </Box>
      </DetailTemplate>
      
      {/* 
      <DetailTemplate title="개요">
        <OrderBookSummary
          orderInfo={receiveOrderInf}
          approvalList={approvalList}
        />
      </DetailTemplate> 
     
      {approval?.docuTxt && approval?.docuTxt !== '' && (
        <DetailTemplate title="결재 참고사항">
          <Box>
            <Typography variant="body2" component="div">
              {approval?.docuTxt}
            </Typography>
          </Box>
        </DetailTemplate>
      )}
      <DetailTemplate title="상세내역">
      </DetailTemplate>
     
      <DetailTemplate title="최종 매출 이익 (내부거래 포함)">
        <SalesProfitInfoContainer
          orderInfo={receiveOrderInf}
          project={project}
        />
      </DetailTemplate>
       
      <DetailTemplate title="원가산출내역">
       
      </DetailTemplate>
      */}
    </>
  );
};

export default ApprovalOrderViewContainer;
